export default "__VITE_ASSET__ChGr$amB__"